import React from 'react';
import FindifyRecommendations from './FindifyRecommendations';

export const FindifyComponent = ({ id }) => {
  return id && <FindifyRecommendations id={id?.value} />;
};
